export default "__VITE_ASSET__DOGe_84W__"